<template>
	<div>
		<header class="flex-apart">
			<h1 class="alpha heavy">Service providers</h1>
			<div v-if="$can('serviceProvider.create')">
				<ul>
					<li>
						<button
							class="button button--primary--small"
							@click.prevent="openCreateServiceProviderModal()">Create service provider
						</button>
					</li>
				</ul>
			</div>
		</header>
		<VStoreTable :links="tableLinks" class="v-table" store-name="serviceProviders"/>
	</div>
</template>
<script>
import VStoreTable from "@/common/components/v-table/v-store-table.vue";
import Index from "../../../../components";

let index = new Index("serviceProviders");

export default {
	components: {
		VStoreTable,
	},

	computed: {
		// ...index.computed(),
		tableLinks() {
			return {
				"profile.name": (data, column) => this.route("service-providers/:serviceProvider", data),
			};
		},
	},

	methods: {
		// ...index.actions(),
		openCreateServiceProviderModal() {
			this.$vmodal.open({
				component: () => import("./modals/CreateServiceProvider.vue"),
			});
		},
	},

	// created() {
	// 	this.getModels();
	// },
};
</script>
